import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { QuestionnaireMutationInput, QuestionnaireMutationPayload } from '../../schema';
import { Inject } from '../helpers';
import { UserService } from './userService';
import { mutation } from '../components/master/questionnaire/constant';

export class QuestionnaireService {
  static instance: QuestionnaireService;
  @Inject userService: UserService;

  constructor() {
    if (QuestionnaireService.instance) {
      return QuestionnaireService.instance;
    } else {
      QuestionnaireService.instance = this;
    }
  }

  add(data: QuestionnaireMutationInput, onSuccess: (reponse) => void, onError: (response) => void) {
    // addedBy is the CREATOR, so it is only stamped on create. This used to be
    // injected unconditionally, and since the mutation is a full replacement
    // (fields='__all__'), every edit -- and every Activate/Deactivate toggle,
    // which routes through here -- silently rewrote the owner to whoever
    // clicked, with no audit trail.
    const input: any = { ...data };
    if (!input.id) {
      input.addedBy = this.userService.user$.value.id;
    }
    Api.graphql<{ input: QuestionnaireMutationInput }, QuestionnaireMutationPayload>(
      API_URL,
      { input },
      mutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (response) => {
        onError(response);
      },
    );
  }
}
